module.exports = __webpack_public_path__ + "img/8.68248a7b.jpg";